import firebaseService from "@/services/firebase.service";
import storageService from "@/services/storage.service";
import utilService from "@/services/util.service";
import axios from "axios";
import axiosRetry from "axios-retry";
import { TYPE } from "vue-toastification";

const baseURL = (process.env.VUE_APP_API_URL ? "https://" + process.env.VUE_APP_API_URL + "/api" : "/api");

const instance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to check session before making requests
instance.interceptors.request.use(
  (config) => {
    // Check if we're in logout flow and cancel new requests
    if (utilService.isInLogoutFlow()) {
      return Promise.reject(new axios.Cancel("Request cancelled due to session expiry"));
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for enhanced error handling
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't process errors if we're already in logout flow
    if (utilService.isInLogoutFlow()) {
      return Promise.reject(error);
    }

    // Handle 401 errors
    if (error.response && error.response.status === 401) {
      const originalConfig = error.config;
      let user = storageService.getUser();
      
      if (originalConfig.url !== "/auth/signin" && user.uid) {
        utilService.handle401Error();
        return Promise.reject(error);
      }
    }
    
    return Promise.reject(error);
  }
);

axiosRetry(instance, {
  retries: 3, // number of retries
  retryDelay: (retryCount) => {
    return retryCount * 2000; // time interval between retries
  },
  retryCondition: async (error) => {
    // Don't retry if we're in logout flow
    if (utilService.isInLogoutFlow()) {
      return false;
    }

    // if retry condition is not specified, by default idempotent requests are retried
    const originalConfig = error.config;
    let user = storageService.getUser();
    if (originalConfig.url !== "/auth/signin" && error.response && user.uid) {
      if (error.response.status == 401 && originalConfig) {
         // request for a new token\
        // await firebaseService.getAuthToken();
        // // update the error config with new token
        // // error.config.__isRetryRequest = true;
        // let firebaseToken = storageService.getToken();
        // if (firebaseToken.length > 0) {
        //   error.config.headers!.token = `Firebase ${firebaseToken}`;
        //   // instance(error.config);
        //   return true;
        // }
        // Don't trigger multiple 401 errors
        if (!utilService.isInLogoutFlow()) {
          utilService.handle401Error();
        }
        return false;
      }
    }
    return error.response!.status === 503;
  },
});

export default instance;



export const api = instance